import React, {useEffect} from 'react';
import {
    Route,
    Switch,
    RouteChildrenProps,
    Redirect,
    useLocation,
} from 'react-router-dom';
import {routes} from './../constants/routes';
import styles from './layout.module.scss';
import Sidebar from './../components/Sidebar';
import Header from './../components/Header';
import BackDropLoader from './../components/BackDropLoader';
import {mediakitUserExist} from '../Helper/generalHelper';
import {isRtl} from '../features/util';
import {useTranslation} from 'react-i18next';

type Props = {
    active: boolean
};

const Layout: React.FunctionComponent<{}> = () => {
    const location = useLocation();
    const userExist = mediakitUserExist();
    const {t, i18n} = useTranslation();

    useEffect(() => {
        if (location?.pathname != '/mediakit/profile/my-profile' && !userExist) {
            window.location.href = '/mediakit/profile/my-profile';
        }
    }, [location, userExist]);
    return (
        <div className={styles.layout_container}>
            <BackDropLoader />
            <div className={styles.layout_left}>
                <Sidebar />
            </div>
            <div className={styles.layout_right}>
                <div>
                    <Header />
                </div>
                <div>
                    <Switch>
                        {routes.map((route, index) => {
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    render={(
                                        props: RouteChildrenProps<any>,
                                    ) => (
                                        <route.component
                                            name={route.name}
                                            {...props}
                                            {...route.props}
                                        />
                                    )}
                                />
                            );
                        })}
                        <Route path='/*'>
                            <Redirect to='/mediakit/profile/my-profile'></Redirect>
                        </Route>
                    </Switch>
                </div>
            </div>
        </div>
    );
};

export default Layout;
